import { QuestionnaireTransactionEnum } from 'src/utils/types';
import { QuestionnaireTypeEnum } from 'src/types';
import { selectTransactionQuestionnaireSlice } from 'src/redux/slices/transactionQuestionnaire';
import { useSelector } from 'react-redux';
import { QuestionnarieModal } from 'src/components/QuestionnarieModal';
import { fillQuestionnaireJsonWithCompletedData } from 'src/utils/questionnaire';
import { sellerFinance } from 'src/constants/surveyJson/sellerFinance';
import { selectTransactionFinance, selectTransactionParticipants } from 'src/redux/slices/transaction';
import { selectUser } from 'src/redux/slices/auth';
import { useQuestionnaire } from '../useQuestionnaire';
import QuestionnaireCard from '../QuestionnaireCard/QuestionnaireCard';
import { DescriptionBlock } from '../styles';
import { modalSx } from './styled';

const SellerFinanceCard = () => {
	const { fullQuestionnaire } = useSelector(selectTransactionQuestionnaireSlice);
	const participants = useSelector(selectTransactionParticipants);
	const finance = useSelector(selectTransactionFinance);
	const user = useSelector(selectUser);
	const { onSubmit, onComplete, onPageChanged, isHidden, isNotAllowed, notAllowedMessage } = useQuestionnaire({
		type: QuestionnaireTransactionEnum.seller_finance,
		questionnaireType: QuestionnaireTypeEnum.TRANSACTION,
	});

	// const submittingError: QuestionnaireSubmittingError | null = useMemo(() => {
	// 	const financeBankAccounts =
	// 		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	// 		finance.data?.sellers.reduce<any[]>((acc, s) => {
	// 			const bankAccounts = fullQuestionnaire?.seller_finance.banking?.[`${s.id}_accounts`] ?? [];

	// 			acc.push(...bankAccounts);

	// 			return acc;
	// 		}, []) ?? [];

	// 	if (!financeBankAccounts.length) {
	// 		return {
	// 			title: 'MISSING BANK ACCOUNTS',
	// 			children: <>Please add at least one proprietor's bank account.</>,
	// 			handleContinueClick: ({ setCurrentPage, setIsSubmitting }) => {
	// 				setIsSubmitting(false);
	// 				setCurrentPage(1);
	// 			},
	// 		};
	// 	}

	// 	return null;
	// }, [fullQuestionnaire?.seller_finance, finance.data?.sellers]);

	if (!fullQuestionnaire || isHidden || !finance.data) return null;

	const completedTransactionSellerFinance = fillQuestionnaireJsonWithCompletedData(
		sellerFinance(participants, fullQuestionnaire, user, finance.data),
		fullQuestionnaire?.seller_finance,
	);

	return (
		<>
			<QuestionnarieModal
				questionnaireType={QuestionnaireTypeEnum.TRANSACTION}
				initialCurrentPage={fullQuestionnaire?.seller_finance?.currentPage ?? 0}
				questionnaireKey={QuestionnaireTransactionEnum.seller_finance}
				onSubmit={onSubmit}
				onComplete={onComplete}
				onPageChanged={onPageChanged}
				surveyJson={completedTransactionSellerFinance}
				modalSx={modalSx}
				status={fullQuestionnaire?.seller_finance.status}
			/>
			<QuestionnaireCard
				questionnaireType={QuestionnaireTypeEnum.TRANSACTION}
				title='Seller Finance'
				type={QuestionnaireTransactionEnum.seller_finance}
				notAllowed={isNotAllowed}
				notAllowedMessage={notAllowedMessage}
			>
				{({ details }) => {
					const bankAccountsAmount = details?.banking?.bank_accounts?.length;

					if (!bankAccountsAmount) return null;

					return (
						<DescriptionBlock>
							{bankAccountsAmount} bank account{bankAccountsAmount >= 2 && 's'} provided
						</DescriptionBlock>
					);
				}}
			</QuestionnaireCard>
		</>
	);
};

export default SellerFinanceCard;
